import React, { useEffect, useRef } from 'react';

export const ParallaxSection = ({ children, speed = 0.15, className = '', ...props }) => {
  const ref = useRef(null);

  useEffect(() => {
    // Check for reduced motion preference
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    const el = ref.current;
    if (!el) return;

    const onScroll = () => {
      const rect = el.getBoundingClientRect();
      const y = rect.top;
      el.style.transform = `translateY(${y * speed}px)`;
    };

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [speed]);

  return (
    <section ref={ref} className={className} {...props}>
      {children}
    </section>
  );
};
